"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmailTemplates = /** @class */ (function () {
    function EmailTemplates($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/post-office/email-templates",
            UPDATE: APPURL + "/api/v1/post-office/email-templates",
            CREATE: APPURL + "/api/v1/post-office/email-templates",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    EmailTemplates.prototype.extract = function (result) {
        return result.data;
    };
    EmailTemplates.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    EmailTemplates.prototype.show = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    EmailTemplates.prototype.get = function () {
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    EmailTemplates.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    EmailTemplates.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    EmailTemplates.prototype.delete = function (data) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + data.id)
            .then(this.cacheResults);
    };
    return EmailTemplates;
}());
EmailTemplates.$inject = ["$http", "APPURL"];
exports.default = EmailTemplates;
